import { BREAK_POINT } from "../config";

export function checkIsDesktop() {
  return window.innerWidth >= BREAK_POINT;
}

export function scrollToElement(elementId, startPointId, scrollOffset = 0) {
  const element = document.getElementById(elementId);
  if (element) {
    const elementTop = element.getBoundingClientRect().top;
    let startPointElBottom = 0;
    if (startPointId) {
      const startPointEl = document.getElementById(startPointId);
      startPointElBottom = startPointEl.getBoundingClientRect().bottom;
    }
    const offsetElementPosition =
      elementTop - startPointElBottom + window.pageYOffset + scrollOffset;
    window.scrollTo(0, offsetElementPosition);
  }
}

export function isScrolledIntoView(el) {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;
  const isVisible = elemTop < window.innerHeight && elemBottom >= 0;
  return isVisible;
}
